module.exports = __webpack_public_path__ + "static/img/22.75500c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/22.png
// module id = DyfC
// module chunks = 5